/* eslint-disable react/no-unescaped-entities */
import { Box, Typography } from '@material-ui/core';
import { Theme, makeStyles } from '@material-ui/core/styles';
import DashboardIcon from '@material-ui/icons/Dashboard';
import React, { useContext } from 'react';
import colorContext from '../../../../Context/colorContext';
import { OrgansI } from '../../../OrgansList';

interface Props {
  organ: OrgansI;
}

export default function Title({ organ }: Props): JSX.Element {
  const { colors } = useContext(colorContext);
  const useStyles = makeStyles((theme: Theme) => ({
    main: {
      width: '100%',
      minHeight: 200,
      height: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.cardAccentColor,
      boxShadow: colors.boxShadowColor,
    },
    organIcon: {
      width: 70,
      height: 70,
      color: colors.textAccentColor,
      marginBottom: 26,
      [theme.breakpoints.down('sm')]: {
        width: 31.67,
        height: 34.57,
      },
    },
    organAcronym: {
      fontSize: theme.typography.pxToRem(16),
      textTransform: 'uppercase',
      fontWeight: 400,
      color: colors.textAccentColor,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(16),
        textAlign: 'center',
      },
    },
    organTitle: {
      fontSize: theme.typography.pxToRem(32),
      color: colors.textAccentColor,
      marginBottom: 16,
      fontWeight: 800,
      lineHeight: '51.2px',
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(24),
        textAlign: 'center',
      },
    },
  }));
  const classes = useStyles();

  return (
    <Box className={classes.main}>
      <Box
        display='flex'
        maxWidth='1040px'
        alignItems='center'
        width='100%'
        flexWrap='wrap'
        justifyContent='space-between'
      >
        <Box width='90%'>
          <Typography className={classes.organTitle}>{organ.nome}</Typography>
          <Typography className={classes.organAcronym}>
            Encontre o serviço desejado abaixo.
          </Typography>
        </Box>
        <DashboardIcon className={classes.organIcon} />
      </Box>
    </Box>
  );
}
